"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VButton_vue_1 = __importDefault(require("../scraps/VButton.vue"));
var VConfirmationModal_vue_1 = __importDefault(require("../scraps/VConfirmationModal.vue"));
var event_bus_1 = require("../../event-bus");
exports.default = vue_1.default.extend({
    name: "delete-role",
    components: {
        VButton: VButton_vue_1.default,
        VConfirmationModal: VConfirmationModal_vue_1.default
    },
    props: {
        currentRole: {
            type: Object,
            required: true
        }
    },
    data: function () {
        return {
            showModal: false
        };
    },
    methods: {
        onOk: function () {
            this.showModal = false;
            event_bus_1.EventBus.$emit(event_bus_1.events.role.delete, this.currentRole);
        }
    }
});
